var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.27832 19.2501H11.2783V21.0834H0.27832V19.2501ZM4.16499 7.39758L6.75915 4.80341L19.7208 17.7651L17.1267 20.3592L4.16499 7.39758ZM10.655 0.916748L15.8433 6.10508L13.2492 8.69925L8.06082 3.51091L10.655 0.916748ZM2.87249 8.69008L8.06082 13.8784L5.46665 16.4726L0.27832 11.2842L2.87249 8.69008Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.5bde3c7452f78ee2d523d3824c6b2404.svg";
export { ForwardRef as ReactComponent };